export default __webpack_public_path__ + "static/char-thumb-29-f50ae557171f63cf51668954e37d1c64.webp";